import { useEffect, useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import { StafferSlideShows, Lesson, Program, SectionType, SlideGroup } from '@/types/api/LessonOverview';

type UseLessonOverviewProps = {
  lessonId: number,
  locale: string,
  programId: number,
};

export interface LessonOverviewResponse {
  isLoading: boolean;
  lesson: Lesson;
  program: Program;
  sections: SectionType[];
  slideGroups?: SlideGroup[];
  slideShows: StafferSlideShows;
}

const useLessonOverview = ({
  lessonId,
  locale,
  programId,
}: UseLessonOverviewProps): LessonOverviewResponse => {
  const [lesson, setLesson] = useState<Lesson>(null);
  const [sections, setSections] = useState<SectionType[]>([]);
  const [slideShows, setSlideShows] = useState<StafferSlideShows>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [program, setProgram] = useState<Program>(null);
  const [slideGroups, setSlideGroups] = useState<SlideGroup[]>([]);

  const lessonOverviewPath = Routes.plato_api_program_lesson_overview_index_path(
    programId, lessonId, { locale },
  );

  useEffect(() => {
    axios.get(lessonOverviewPath)
      .then((response) => {
        setLesson(response.data.lesson);
        setProgram(response.data.program);
        setSections(response.data.sections);
        setSlideShows(response.data.slideShows);
        setSlideGroups(response.data.slideGroups);
      }).finally(() => setIsLoading(false));
  }, []);

  return {
    isLoading,
    lesson,
    program,
    sections,
    slideGroups,
    slideShows,
  };
};

export default useLessonOverview;
